import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

const DropdownInner = ({ question, answer, index, forceDropdown }) => {
  const [dropdownInnerLevel, setDropdownInnerLevel] = useState(false);

  useEffect(() => {
    if (forceDropdown) {
      setDropdownInnerLevel(true);
      const inView = document.getElementById(`${question.replace(/\s/g, '')}`);
      if (inView) {
        inView.scrollIntoView({
          behavior: 'smooth',
        });
      }
    }
  }, [forceDropdown]);

  const answerAmended = { __html: answer };
  return (
    <div className="dropdown-question-answer-container" key={index}>
      <button
        className={` ${dropdownInnerLevel ? 'uncollapsed' : 'collapsed'}`}
        key={index}
        onClick={() => {
          setDropdownInnerLevel(!dropdownInnerLevel);
        }}
        id={`${question.replace(/\s/g, '')}`}
      >
        {question}
        <FontAwesomeIcon icon={faChevronDown} />
      </button>
      {dropdownInnerLevel && (
        <ul>
          <li dangerouslySetInnerHTML={answerAmended} />
        </ul>
      )}
    </div>
  );
};

export default DropdownInner;
